<template>
    <div class="home">
        <div class="blank-page" :class="{ 'hidden': ready }"></div>
        <modal-contact-us></modal-contact-us>
        <div class="container">
            <h3 class="home-title">{{ $t('home_search_for_product') }}</h3>

            <p v-if="$te('introduction_text')">{{ $t('introduction_text') }}</p>
            <!-- Opening page -->
            <div v-if="$store.state.search.alternative === ''" class="front">
                <div>{{$t("what_type_are_you_looking_for")}}</div>
            </div>

            <div :class="{
                        'alternatives': true,
                        'alternatives-large': $store.state.search.alternative === '',
                        'alternatives-small': $store.state.search.alternative !== ''
                    }"
                v-if="!led_only">
                <div :class="{active: $store.state.search.alternative === 'conventional'}"
                        @click="setAlternative('conventional')">
                    <div class="images">
                        <img class="icon-lamp">
                        <img class="icon-drive">
                    </div>

                    <div class="text">
                        <div class="title">{{$t("conventional_alternative")}}</div>
                    </div>
                </div>

                <div :class="{active: $store.state.search.alternative === 'led'}"
                        @click="setAlternative('led')">
                    <div class="images">
                        <div class="image-container">
                            <img class="icon-led">
                            <div class="energy-efficient">{{$t("energy_efficient")}}</div>
                        </div>
                        <div v-if="$store.state.search.alternative !== ''" class="dummy"></div>
                    </div>

                    <div class="text">
                        <div class="title">{{$t("led_alternative")}}</div>
                    </div>
                </div>
            </div>

            <search-block v-if="$store.state.search.alternative !== ''" />
        </div>
    </div>
</template>

<script>
import OctSearch from '@/components/Search';
import SearchResultsList from "@/components/SearchResultList";
import SearchBlock from "@/components/SearchBlock";
import { attachTooManyRequestsHook } from "@/services/http";
import ModalContactUs from '@/components/ModalContactUs';
import { http } from "@/services/http";

export default {
    name: 'home',

    components: {
        SearchResultsList,
        SearchBlock,
        OctSearch,
        ModalContactUs,
    },

    data() {
        return {
            led_only: false,
            ready: false,
        }
    },

    computed: {
        hasResults() {
            return this.$store.state.search.searchResults.length > 0;
        },
        selectedResult() {
            return this.$store.state.search.results.length > 0;
        },
        userIsGuest() {
            return this.$store.state.auth.userExplicitlyProceedsWithoutLogin;
        }
    },

    mounted() {
        if(this.userIsGuest) {
            attachTooManyRequestsHook();
        }
    },

    created() {
        const locale = this.parseLocale(this.$route.query.locale);
        const vendor = this.parseVendor(this.$route.query.vendor);
        const defaultFilter = this.$route.query.defaultFilter;

        this.$store.commit('ui/defaultOpenFilter', defaultFilter);
        this.$store.commit('ui/currentLanguage', locale.language);
        this.$store.dispatch('search/setCountry', locale.country);
        this.$store.dispatch('search/setVendor', vendor);
    
        this.$store.dispatch('auth/setUserExplicitlyProceedsWithoutLogin', true);
        
        // Query market data
        if (locale.country !== "global")
            http.get(`/markets/${locale.country}`).then(response => {
                if (response.data === null) {
                    console.log("Invalid market meta data for current country.");
                    return;
                }
                
                const lang_list = response.data.languages.split(" ");

                this.led_only = response.data.led_only;
                if (this.led_only) {
                    this.setAlternative('led');
                }
                this.$store.commit('ui/availableLanguages', lang_list);
                this.$store.dispatch('ui/sanitizeLanguage', lang_list[0]);

                this.ready = true;
            });
        else {
            this.ready = true;
            this.led_only = true;
            this.setAlternative('led');
        }
            
    },

    methods: {
        search() {
            this.$store.dispatch('search/search');
        },

        setAlternative(alternative) {
            if (alternative === this.$store.state.search.alternative)
                return;

            this.$store.commit('search/alternative', alternative);
            this.$store.commit('search/searchQuery', "");
            this.$store.commit('search/results', []);
            this.$store.commit('search/searchResults', []);
            this.$store.commit("search/showSearchResults", false);
            this.$store.dispatch('search/getFacets');
        },

        parseLocale(locale_str) {
            if (locale_str === undefined)
                return { language: "en", country: "global" };

            const locale = locale_str.split("_");
            if (locale[0] === "global")
                return { language: "en", country: "global" };
            if (locale.length < 2) {
                // We have a bad locale string. Fallback to global
                return { language: "en", country: "global" };
            }
            return { language: locale[0].toLowerCase(), country: locale[1].toLowerCase() }
        },

        parseVendor(vendor_str) {
            if (vendor_str === undefined)
                return "default";
            return vendor_str;
        }
    }
};
</script>

<style lang="scss">

    .blank-page {
        position: fixed;
        top: 0;
        left: 0;
        z-index: 999;
        width: 100vw;
        height: 100vh;
        background-color: white;
        transition: visibility 0.5s, opacity 0.5s;

        &.hidden {
            visibility: hidden;
            opacity: 0;
        }
    }

    .front {
        font-size: $nc-fsz-normal;
        margin-bottom: 40px;
    }


    // Alternatives buttons

    .alternatives {

        // Direction:
        display: flex;
        flex-direction: row;

        // --- Direction
        
        
        & > div {
            display: flex;
            align-items: center;
            border: $nc-gray-border;
            box-sizing: border-box;
            cursor: pointer;
            box-shadow: 0px 1px 2px 0px rgba(0,0,0,0.5);

            &:first-child {
                margin-right: 20px;
            }

            &.active {
                background-color: $nc-gray-bg;
            }

            .energy-efficient {
                font-size: $nc-fsz-xs;

                color: white;
                background-color: $nc-cyan-dark;

                position: absolute;
                top: 0;
                right: -15%;
                
                width: 60px;
                height: 60px;
                border-radius: 110px;
                text-align: center;
                padding-top: 10px;
                font-size: 12px;
            }

            // Icons
            .icon-lamp {
                content: url($icon-lamp);
            }
            .icon-drive {
                content: url($icon-driver);
            }
            .icon-led {
                content: url($icon-led);    
            }
            &.active, &:hover {
                .icon-lamp {
                    content: url($icon-lamp-active);
                }
                .icon-drive {
                    content: url($icon-driver-active);
                }
                .icon-led {
                    content: url($icon-led-active);
                }
            }
        }

        .title {
            font-size: $nc-fsz-normal;
            font-weight: bold;
        }
        .image-container { position: relative; }

    }


    // Large icons

    .alternatives-large {

        & > div:not(:last-child) {
            margin-right: 20px;
        }

        @include media-breakpoint-down(md) {
            flex-direction: column;

            & > div:not(:last-child) {
                margin-right: initial;
                margin-bottom: 20px;
            }
        }
        
        & > div {
            padding: 40px 40px 40px 40px;
            flex-direction: column;

            @include media-breakpoint-down(md) {
                &:not(:first-child) {
                    margin-right: initial;
                    margin-top: 20px;
                }
            }
        }

        img {
            width: 150px;
            height: 150px;
        }

        .images {
            top: 0;
            left: 0;
            display: flex;
            justify-content: space-around;

            & > *:not(:last-child) {
                margin-right: 20px;
            }
        }

        .title {
            margin-top: 20px;
            text-align: center;
        }
    }


    // Small icons

    .alternatives-small {
        margin-bottom: 40px;
        flex-direction: row;
        justify-content: space-between;

        @include media-breakpoint-down(md) {
            flex-direction: column;
            align-items: stretch;
        }

        & > div {
            padding: 15px;
            flex: 1 1 100%;

            &:first-child {
                margin-right: 10px;
            }
            &:not(:first-child) {
                margin-left: 10px;
            }

            & > div:not(:first-child) {
                margin-left: 15px;
            }

            @include media-breakpoint-down(md) {
                margin-right: initial !important;
                margin-left: initial !important;
                &:not(:first-child) {
                    margin-top: 20px;
                }
            }
        }
        
        .images {
            display: flex;
            margin-right: 10px;

            img, .dummy {
                width: 100px;
                height: 100px;
            }
            .dummy {
                width: 40px;
            }
            > *:not(:first-child) {
                margin-left: 10px;
            }
        }

        .text {
            display: inline-block;

            .energy-efficient {
                color: $nc-blue-primary;
            }

            .title {
                font-size: $nc-fsz-l;
            }
        }
    }

    // --------



  .home-title {
    margin-top: 2rem;
    margin-bottom: 40px;
  }
    .home {
        height: calc(100% - 115px);
        display: flex;
        flex-direction: column;
    }
    .how_it_works {
      margin-bottom: 40px;

        h2 {
            color: $dark-gray;
            margin: 0 0 2rem 0;
        }
        p {
            &:last-of-type {
                margin: 0 0 2rem 0;
            }
        }
        button {
            background-color: $blue;
            border: 1px solid $blue;
            font-weight: 400;
        }
    }

    .visual_explanation {
        ol.numbered {
            color: $dark-blue;
            list-style-type: none;
            margin: 0;
            padding: 0;
            li {
                margin: 0;
                padding: 0;
            }
            p {
                color: $dark-gray;
            }
        }
        ol.numbered {
            $bullet-line-width: 1px;
            $bullet-border-width: $bullet-line-width;
            $bullet-background-color: white;
            $bullet-size: 60px;

            border-left: $bullet-line-width solid $dark-blue;
            counter-reset: numbered-list;
            margin-left: 10px;
            position: relative;
            li {
                margin-bottom: 50px;
                padding-left: 50px;
                &:last-child {
                    border-left: $bullet-line-width solid $bullet-background-color;
                    margin-left: -$bullet-line-width;
                }
                &:before {
                    $half-of-font-size: -0.5em;
                    background-color: $white;
                    border: $bullet-border-width solid $dark-blue;
                    border-radius: 50%;
                    color: $dark-blue;
                    content: counter(numbered-list, decimal);
                    counter-increment: numbered-list;
                    display: block;
                    font-size: 26px;
                    font-weight: bold;
                    width: $bullet-size;
                    height: $bullet-size;
                    margin-top: $half-of-font-size;
                    line-height: $bullet-size;
                    position: absolute;
                    left: -$bullet-size / 2 - $bullet-line-width / 2 - $bullet-border-width;
                    text-align: center;
                }
            }
        }
    }
</style>
